<div class="no-access-container">
  <div class="no-access-card">
    <div class="no-access-symbol">!</div>
    <h1>Access Restricted</h1>
    <p class="primary-message">You don't have permission to access the CDS application.</p>
    <p class="secondary-message">
      Please <a [href]="accessRequestUrl" class="support-link">raise a support ticket</a>
      or email support at:
    </p>
    <div class="secondary-message">
      <span class="support-link">{{mailDL}}</span>
    </div>
  </div>
</div>